import { TableCell, TableCellProps } from '@mui/material'

const TableHeadCell = (props: TableCellProps) => {
    const { sx, children, ...rest } = props
    return (
        <TableCell
            sx={{
                fontWeight: 600,
                backgroundColor: 'var(--blue-50)',
                ...sx,
            }}
            {...rest}
        >
            {children}
        </TableCell>
    )
}

export default TableHeadCell
